<template>
  <div class="home">
    <div class="home-img">
      <img alt="vector illustration" src="@/assets/images/coffee.png" />
    </div>
    <div class="home-text">
      <h1 class="name">
        Anastasia
        <br class="line-break" />Laczko
      </h1>
      <p class="description">
        Graduate Software Engineer
      </p>
      <div class="icons">
        <a
          v-for="link in links"
          v-bind:key="link.name"
          :href="link.url"
          target="_blank"
        >
          <i :class="`icon fab ${link.name} ${link.icon}`"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { links } from "@/data/contactLinks.js";
export default {
  name: "Home",
  data() {
    return {
      links: links
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";

.home {
  flex-grow: 1;
  min-height: 100vh;
  padding: 100px;
  max-width: 1400px;
  margin: 0 auto;

  .home-text {
    .name {
      font-family: $accent-font;
      font-weight: 600;
      color: $accent-blue;
      margin-bottom: 0;
      line-height: 1.2em;
      font-size: $font-L;
    }

    .description {
      margin-top: 0.5em;
      font-size: $font-S;
      color: $dark-grey;
    }

    .icons {
      .icon {
        font-size: 40px;
        margin: 0 10px 0 10px;
        transition-duration: 0.3s;

        &:hover {
          cursor: pointer;
        }
      }

      .linkedin-logo {
        color: #6a9cc9;
        margin-left: 0;

        &:hover {
          color: #0077b5;
        }
      }

      .github-logo {
        color: #a569a5;

        &:hover {
          color: #590059;
        }
      }

      .medium-logo {
        color: $light-grey;

        &:hover {
          color: $dark-grey;
        }
      }
    }
  }

  .home-img {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      max-width: 750px;
      height: auto;
    }
  }

  .btn {
    display: inline-block;
    font-weight: semi-bold;
    font-size: $font-S;
    background: $accent-very-light-blue;
    color: $accent-darker-blue;
    padding: 10px 20px;
    margin: 10px auto 0 auto;
    border-radius: 5px;
    text-decoration: none;
    transition: 0.3s;
  }

  @media only screen and (min-width: $phone-S) {
    padding: 80px 20px 20px 20px;

    .home-text {
      align-items: center;
      text-align: center;

      .description {
        margin: 0.6em 0 1.5em 0;
      }

      .line-break {
        display: none;
      }
    }
  }

  @media only screen and (min-width: $tablet-potrait) {
    .home-text {
      .name {
        font-size: 3em;
      }

      .description {
        font-size: $font-M;
      }
    }
  }

  @media only screen and (min-width: $desktop-lg) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
    padding: 0 100px;

    .home-text {
      text-align: left;
      margin-right: 50px;
      .name {
        font-size: 5em;
      }
      .icons {
        padding-bottom: 100px;
      }
      .line-break {
        display: inline;
      }
    }
  }
}
</style>
